import React from 'react';
import { Hero } from './components/Hero';
import { BookInfo } from './components/BookInfo';
import { Features } from './components/Features';
import { PurchaseOptions } from './components/PurchaseOptions';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Hero data-id="element-1" />
      <BookInfo data-id="element-2" />
      <Features data-id="element-3" />
      <PurchaseOptions data-id="element-4" />
      <CallToAction data-id="element-5" />
      <Footer data-id="element-6" />
      <SalesPopup data-id="element-7" />
    </div>;
}